import { useMemo } from 'react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import last from 'lodash/last';
import Route from './Route';
import type { Props as RouteProps } from './Route';

export interface Props extends RouteProps {
	classNames: string;
	timeout: number;
}

const TransitionRoute: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { state, stateId, classNames, timeout, children } = props;
	const key = useMemo(() => last(state?.toStrings()) || '', [state]);

	return (
		<TransitionGroup component={null}>
			<CSSTransition
				key={key}
				classNames={classNames}
				timeout={timeout}
				mountOnEnter
				unmountOnExit
			>
				<Route state={state} stateId={stateId}>
					{children}
				</Route>
			</CSSTransition>
		</TransitionGroup>
	);
};

export default TransitionRoute;
